import i18n from '@/plugins/i18n';

/**
 * N-291 (3A): los avisos de que algo ha ido bien, iguales en las siete secciones del catálogo (Viajes, Alojamientos,
 * Transporte, Servicios extra, Actividades, Paquetes y Proveedores). Los textos nuevos van en el panel (decisión 2A);
 * «Guardado correctamente» ya existía en el servidor.
 */
export function avisarGuardado(bus) {
	bus.$emit('success', { message: i18n.t('success_saved_message') });
}

export function avisarBorrado(bus) {
	bus.$emit('success', { message: 'Borrado correctamente' });
}

export function avisarPublicado(bus, publicado: boolean) {
	bus.$emit('success', { message: publicado ? 'Publicado' : 'Despublicado' });
}
